<script lang="ts">
	import { applyScale, uiScale, uiScaleOptions } from './uiScaleConfig'
	import { onMount } from 'svelte'

	onMount(() => {
		const currentOption = uiScaleOptions.find((option) => option.value === uiScale.current)
		if (currentOption) {
			applyScale(currentOption.scale)
		}
	})
</script>
